import { forwardRef, RefObject, useEffect } from 'react';

import { TransitionState } from 'src/enums/TransitionState';

type TransitionCallBack = (...args: unknown[]) => void;

type TransitionProps = {
	duration: number;
	enterState: boolean;
	onEntering?: TransitionCallBack;
	onEntered?: TransitionCallBack;
	onExiting?: TransitionCallBack;
	onExited?: TransitionCallBack;
	children: JSX.Element;
};

function Transition(props: TransitionProps, ref: RefObject<HTMLElement>) {
	const { enterState, duration, onEntering, onEntered, onExiting, onExited } = props;

	const { ENTERING, ENTERED, EXITING, EXITED } = TransitionState;

	function toggleClass(name: TransitionState) {
		if (!ref?.current) {
			return;
		}

		ref.current.classList.remove(...Object.values(TransitionState));
		ref.current.classList.add(name);
	}

	useEffect(() => {
		if (enterState) {
			toggleClass(ENTERING);
			onEntering?.();
		} else {
			toggleClass(EXITING);
			onExiting?.();
		}

		setTimeout(() => {
			if (enterState) {
				toggleClass(ENTERED);
				onEntered?.();
			} else {
				toggleClass(EXITED);
				onExited?.();
			}
		}, duration);
	}, [ref, enterState]);

	return props.children;
}

export default forwardRef(Transition);
